module.exports = __webpack_public_path__ + "img/paat_paberist.70f4717b.jpg";